import healthImg from "../../../assets/icons/health.png";
import wasteImg from "../../../assets/icons/waste.png";
import edtechImg from "../../../assets/icons/edtech.png";

export const themeData = [
    {
        img: edtechImg,
        title: "EdTech"
    },
    {
        img: healthImg,
        title: "Healthcare"
    },
    {
        img: wasteImg,
        title: "Waste Management",
    }
];